import { KeyboardCommandMessageKey } from '@infomaniak/ksuite-bridge';
function handleKeydown(e) {
    if (e.altKey && e.code === 'KeyK' && !e.metaKey) {
        window['webComponentsStore'].ksuiteBridge?.sendMessage({
            type: KeyboardCommandMessageKey,
            code: e.code,
            altKey: true,
        });
        e.stopPropagation();
    }
}
export const SpaceShortcutTask = {
    enable: () => {
        window.addEventListener('keydown', handleKeydown, true);
    },
};
